import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() {
  }


  get loading() {
    return this.isLoading;
  }

  setLoading(isLoading: boolean) {
    this.isLoading.next(isLoading);
  }
}
